import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import GiftSummaryContent from "modules/GiftSummary";

import React from "react";

import { setTitle } from "utilities/helper/setTitle";

const GiftSummaryPage: React.FC = () => {
  setTitle("Membership List");
  return (
    <Auth>
      <Layout>
        <GiftSummaryContent />
      </Layout>
    </Auth>
  );
};

export default GiftSummaryPage;
